function CollapseView({ raw, onEdit, onDelete }) {
  const DataCard = ({ icon, label, value, accent = "#83c14a" }) => (
    <div style={{
      background: "#fff",
      border: "1px solid #E5E7EB",
      borderRadius: "10px",
      padding: "16px",
      position: "relative",
      overflow: "hidden",
      transition: "all 0.2s ease"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "none";
    }}>
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "4px",
        height: "100%",
        background: accent
      }}></div>
      <div className="d-flex align-items-start gap-3">
        <div style={{
          width: "40px",
          height: "40px",
          borderRadius: "10px",
          background: `${accent}15`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0
        }}>
          <i className={icon} style={{ fontSize: "1.125rem", color: accent }}></i>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: "0.75rem", color: "#6B7280", fontWeight: "600", marginBottom: "4px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
            {label}
          </div>
          <div style={{ fontSize: "1rem", color: "#111827", fontWeight: "700", wordBreak: "break-word" }}>
            {value || "—"}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{
      background: "#F9FAFB",
      border: "1px solid #E5E7EB",
      borderRadius: "12px",
      padding: "20px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)"
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "20px",
        paddingBottom: "16px",
        borderBottom: "2px solid #E5E7EB"
      }}>
        <i className="bi bi-grid-3x3-gap-fill" style={{ fontSize: "1.25rem", color: "#83c14a" }}></i>
        <h6 style={{ margin: 0, fontSize: "1rem", fontWeight: "700", color: "#111827" }}>
          Category Details
        </h6>
      </div>

      <div className="row g-3 mb-4">
        <div className="col-md-6">
          <DataCard 
            icon="bi bi-tag-fill"
            label="Category Name"
            value={raw?.name}
            accent="#83c14a"
          />
        </div>

        <div className="col-md-6">
          <DataCard 
            icon="bi bi-file-text-fill"
            label="Description"
            value={raw?.description}
            accent="#3B82F6"
          />
        </div>
      </div>

      <div className="d-flex gap-3">
        <button 
          className="btn text-white" 
          onClick={onEdit}
          style={{
            background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)",
            border: "none",
            padding: "10px 20px",
            fontWeight: "600",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(131, 193, 74, 0.3)",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow = "0 4px 12px rgba(131, 193, 74, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 2px 8px rgba(131, 193, 74, 0.3)";
          }}
        >
          <i className="bi bi-pencil-fill me-2"></i> Edit
        </button>
        <button 
          className="btn btn-danger" 
          onClick={onDelete}
          style={{
            padding: "10px 20px",
            fontWeight: "600",
            borderRadius: "8px",
            border: "none",
            boxShadow: "0 2px 8px rgba(220, 38, 38, 0.3)",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow = "0 4px 12px rgba(220, 38, 38, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 2px 8px rgba(220, 38, 38, 0.3)";
          }}
        >
          <i className="bi bi-trash-fill me-2"></i> Delete
        </button>
      </div>
    </div>
  );
}

export default CollapseView;
